exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.text-center {\n  text-align: center;\n}\n.slide-loading {\n  padding: 40px 58px;\n}\n.loading__wrapper {\n  width: 100%;\n  height: 6px;\n  position: relative;\n  background-color: #f6f6f6;\n  overflow: hidden;\n}\n.loading__line {\n  position: absolute;\n  top: 0;\n  width: 350px;\n  height: 100%;\n  background-color: #00afa1;\n  animation: flow-to-right 3s linear infinite;\n}\n@keyframes flow-to-right {\nfrom {\n    left: -350px;\n}\nto {\n    left: 100%;\n}\n}\n", ""]);

// exports
